import FeatureGate from "@/src/components/feature-gate";
import LeaderboardScreen from "@/src/screens/leaderboard/leaderboard";

export default function LeaderboardRoute() {
  return (
    <FeatureGate feature="leaderboard">
      <LeaderboardScreen />
    </FeatureGate>
  );
}
